export class FileDetails {
    fileId: string;
    fileName: string;
    url: string;

    constructor(fileId: string, fileName: string, url?: string) {
        this.fileId = fileId;
        this.fileName = fileName;
        this.url = url;
    }
}
